import React, { useRef } from 'react';
var VeltAutocompleteChip = function (props) {
    var type = props.type, email = props.email, userObject = props.userObject, userId = props.userId, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-autocomplete-chip", { ref: ref, type: type, email: email, "user-object": userObject ? (typeof userObject === 'object' ? JSON.stringify(userObject) : userObject) : undefined, "user-id": userId }, children));
};
export default VeltAutocompleteChip;
